import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationES from './locales/es/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
  EN: {
    translation: translationEN,
  },
  FR: {
    translation: translationFR,
  },
  ES: {
    translation: translationES,
  },
  AR: {
    translation: translationAR,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'FR', // Langue par défaut
    fallbackLng: 'EN', // Langue de secours
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
